import React from 'react';
import BaseReportPage from '../../../components/reports/BaseReportPage';

const StockExpiryReport = () => {
  const columns = [
    {
      key: 'itemName',
      label: 'Item',
      type: 'text'
    },
    {
      key: 'itemType',
      label: 'Type',
      type: 'text'
    },
    {
      key: 'category',
      label: 'Category',
      type: 'text'
    },
    {
      key: 'batchNumber',
      label: 'Batch No.',
      type: 'text'
    },
    {
      key: 'currentStock',
      label: 'Stock Qty',
      type: 'number'
    },
    {
      key: 'expiryDate',
      label: 'Expiry Date',
      type: 'date'
    },
    {
      key: 'daysToExpiry',
      label: 'Days to Expiry',
      type: 'number'
    },
    {
      key: 'stockValue',
      label: 'Stock Value',
      type: 'currency'
    },
    {
      key: 'expiryStatus',
      label: 'Status',
      type: 'status'
    }
  ];

  return (
    <BaseReportPage
      title="Stock Expiry Report"
      description="Monitor inventory items approaching expiration dates"
      reportType="stockExpiry"
      columns={columns}
    />
  );
};

export default StockExpiryReport;